<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title"
      >Operations Standard List</mat-card-title
    >
  </mat-card-header>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row">
      <div class="col filter-panel">
        <app-view-all-operations-standards-list-filter
          [isFromLocation]="isFromLocation"
          (messageEvent)="receivedFilteration($event)"
        ></app-view-all-operations-standards-list-filter>
      </div>
      <div class="collpsible-panel">
        <button class="btn-collapse" mat-icon-button aria-label="Collapse">
          <i class="material-icons"> expand_less </i>
        </button>
        <button class="btn-expand" mat-icon-button aria-label="Expand">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="row">
        <div class="col-12 text-left" width="140">
          <mat-form-field>
            <input
              matInput
              placeholder="Search by Title or Description"
              value="{{ searchKey }}"
              (keyup.enter)="addSearchKey(key)"
              name="search"
              #key
            />
            <button
              mat-button
              *ngIf="searchKey"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="searchKey = ''; addSearchKey(searchKey)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div *ngIf="grses.length > 0">
            <mat-form-field>
              <mat-select
                [value]="pageSize"
                name="nOfRows"
                #items
                (selectionChange)="selectedItemsPerPageChange(items)"
              >
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-6 float-right">
          <!-- <button disabled> -->
          <a
            *ngIf="grses.length > 0 && isDownloading"
            class="float-right"
            disabled
          >
            Downloading, Please wait...
            <svg
              class="fontawesomesvg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <!--! Font Awesome Free 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. -->
              <path
                d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
              />
            </svg>
          </a>
          <a
            *ngIf="grses.length > 0 && !isDownloading"
            class="float-right"
            href="javascript:void(0);"
            (click)="downloadExcel()"
            style="color: #0b59ca; text-decoration: none; cursor: pointer"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-bottom: 2px; margin-right: 2px"
            >
              <path
                d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Download All
          </a>
          <!-- </button> -->
        </div>
      </div>
      <table
        *ngIf="grses.length > 0"
        class="table nrbes-grid"
        matSort
        (matSortChange)="sortData($event)"
      >
        <thead class="thead-light">
          <tr>
            <th width="120" scope="col" mat-sort-header="title">Title</th>
            <th scope="col-2" width="40%" mat-sort-header="desc">
              Description
            </th>
            <th width="120" scope="col-2" mat-sort-header="category">
              Category
            </th>
            <th scope="col" width="110">Location</th>
            <th scope="col" width="110">Sub Location</th>
            <!--<th scope="col" width="170">Type</th>-->
            <th
              scope="col"
              width="80"
              *ngIf="userRole == userRoleEnum.GlobalAdmin"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of grses" (click)="rowSelected(item)">
            <td class="title-cell">{{ item.title }}</td>
            <td class="description">{{ item.description }}</td>
            <td class="category-cell">{{ item.category.name }}</td>
            <td class="location-cell">{{ getLocationNames(item) }}</td>
            <td class="description">{{ item.subLocationType.name }}</td>

            <!--<td class="hide-sm"> {{item.standardType.name}}</td>-->
            <td *ngIf="userRole == userRoleEnum.GlobalAdmin">
              <div class="row grid-actions hide-sm">
                <div class="col-6">
                  <a
                    class="action-controls"
                    (click)="openDeleteModal(item, $event)"
                    routerLinkActive="active"
                    title="clear"
                    ><i class="material-icons"> clear </i></a
                  >
                </div>
                <div class="col-6">
                  <a
                    class="action-controls"
                    (click)="onEdit(item.id)"
                    routerLinkActive="active"
                    title="Edit"
                    href="javascript:void(0);"
                    ><i class="material-icons"> create </i></a
                  >
                </div>
              </div>

              <a
                (click)="actionMenuOpen($event)"
                class="mcd-more-btn show-sm"
                [matMenuTriggerFor]="menu"
                href="javascript:void(0);"
              >
                <i class="material-icons">more_vert</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <span>
                  <button mat-menu-item (click)="onEdit(item.id)">Edit</button>
                  <button
                    mat-menu-item
                    (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                  >
                    Remove
                  </button>
                </span>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="grses.length > 0" class="row">
        <div class="col">
          <ngb-pagination
            class="float-right"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="4"
            [rotate]="true"
            [ellipses]="true"
            [collectionSize]="collectionSize"
            (pageChange)="getStandards()"
          ></ngb-pagination>
        </div>
      </div>
    </div>
    <div *ngIf="grses.length == 0 && !searchKey">
      Please visit the
      <a href="https://spo.mcd.com/sites/global_rsg/Pages/Home.aspx">
        Global Market Resource Center
      </a>
      for current operations resources
    </div>
    <div *ngIf="grses.length == 0 && searchKey">
      No results found based on search terms.&nbsp;&nbsp;<a
        href="javascript:void(0);"
        (click)="addSearchKey(''); getStandards()"
        ><span> Go Back</span></a
      >
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
